var Env = /** @class */ (function () {
    function Env() {
    }
    /**
     * Method can be improved later on - actually we need only to detect if it is ios.
     * 'unknown' can be replace later with the correct OS.
     *
     * @return ios|unknown ( unknown can later be replaced with correct OS )
     */
    Env.prototype.getOS = function () {
        return /iPad|iPhone|iPod/.test(navigator.platform) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
            ? 'ios'
            : 'unknown';
    };
    Env.prototype.supportsTouch = function () {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
            return true;
        }
        // https://git.io/vznFH
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return window.matchMedia(query).matches;
    };
    return Env;
}());
export default Env;
//# sourceMappingURL=env.js.map